import { useQuery } from '@tanstack/react-query';

import React, { useEffect } from 'react';
import { getAllBillings, postBillings } from '../../../services/api/implementation/impl';
import Table from '../../../../shared/components/layout/Table';
import { useMutation } from '@tanstack/react-query';
import { transformData } from '../../../utils/transformData';
import GridWrapper from '../../../../shared/components/layout/GridWrapper';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';

const BillingSummary = () => {
  const userId = Cookies.get('userId');

  // Track page view
  useEffect(() => {
    mixpanel.track('Super Admin Billing Summary Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  // getAllBillings

  // console.log("billings", billings);
  /*  
    Meta data
  */
  const billingsDataFormat = ['company_id', 'total_billed_amount', 'total_due', 'total_collected'];

  /* 
      Helper method calls
   */
  const { data: billings, refetch: refetchbillings } = useQuery({
    queryKey: ['billings'],
    queryFn: () => getAllBillings(),
    onSuccess: (result) => {
      // Check if result is an error object
      if (
        result?.response?.status ||
        result?.message?.includes('Error') ||
        result?.name === 'AxiosError'
      ) {
        mixpanel.track('Super Admin Billing Summary Data Fetch Failed', {
          user_id: userId,
          error_message: result?.response?.data?.message || result?.message || 'Unknown error',
          timestamp: new Date().toISOString()
        });
        toast.error(
          result?.response?.data?.message || result?.message || 'Failed to fetch billing summary'
        );
        return;
      }

      const billingsArray = result ? Object.values(result) : [];
      const totalBilledAmount = billingsArray.reduce(
        (sum, item) => sum + (item?.total_billed_amount || 0),
        0
      );
      const totalDue = billingsArray.reduce((sum, item) => sum + (item?.total_due || 0), 0);
      const totalCollected = billingsArray.reduce(
        (sum, item) => sum + (item?.total_collected || 0),
        0
      );

      mixpanel.track('Super Admin Billing Summary Data Fetch Success', {
        user_id: userId,
        companies_count: billingsArray.length,
        total_billed_amount: totalBilledAmount,
        total_due_amount: totalDue,
        total_collected_amount: totalCollected,
        collection_rate:
          totalBilledAmount > 0 ? ((totalCollected / totalBilledAmount) * 100).toFixed(2) : 0,
        timestamp: new Date().toISOString()
      });
    },
    onError: (err) => {
      mixpanel.track('Super Admin Billing Summary Data Fetch Failed', {
        user_id: userId,
        error_message: err?.response?.data?.message || err?.message || 'Unknown error',
        timestamp: new Date().toISOString()
      });
      toast.error(
        err?.response?.data?.message || err?.message || 'Failed to fetch billing summary'
      );
    }
  });

  const transformedData =
    billings && Object.values(billings)?.map((item) => transformData(item, billingsDataFormat));

  console.log('transformedData', transformedData);

  return (
    <div>
      <div className="mt-[11rem] h-[24rem]">
        <Table
          headers={['Company Name', 'Billed Amount', ' Total Due', 'Total Collected']}
          data={transformedData}
        />
      </div>
    </div>
  );
};

export default BillingSummary;
